export default "__VITE_ASSET__CwxYntxJ__"